<template>
  <div id="category" class="category-container">
    <vs-popup  title="Você tem certeza que deseja continuar?" :active.sync="confirmationPopup" class="sizePopup">
      <p class="mb-5">Essa categoria será removido de todos os contatos!</p>

      <hr/>

      <vs-row
        vs-align="flex-end"
        vs-type="flex"
        vs-justify="flex-end"
        vs-w="12"
        class="mt-5"
      >
        <vs-button color="dark" type="flat" class="mr-3" @click="confirmationPopup = false">
          Cancelar
        </vs-button>

        <vs-button color="danger" type="filled" @click="deleteData">
          Continuar
        </vs-button>
      </vs-row>
    </vs-popup>

    <vs-table
      ref="table"
      noDataText="Sem dados disponíveis"
      v-model="selected"
      search
      :data="groupsOfCustomer"
      @search="searchFilter"
      @sort="sortFilter"
      :sst="true"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div
            v-if="canSee('add')"
            class="
              p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between
              text-lg font-medium text-base text-primary border border-solid border-primary
            "
            @click="addNewData"
          >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Adicionar Novo</span>
          </div>
        </div>


        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4"
        >
          <div
            class="
              p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
              cursor-pointer flex items-center justify-between font-medium
            "
          >
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                groupsOfCustomer.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : groupsOfCustomer.length
              }} de {{ queriedItems }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Nome</vs-th>
        <vs-th>Etiqueta</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" ref="vsTrElement">

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <vs-icon icon="label" size="large" :color="tr.color_tag"></vs-icon>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                v-if="canSee('update')"
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr.id)"
              />

              <feather-icon
                v-if="canSee('delete')"
                icon="TrashIcon"
                svgClasses="w-5 h-5 ml-3 hover:text-primary stroke-current"
                @click.stop="openConfirmationPopup(tr.id)"
              />
            </vs-td>

            <template class="expand-user" slot="expand">
              <table-category-customers
                :tag-list="tr.tag_list"
                :group-id="tr.id"
              />
            </template>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <div class="mt-3 mr-4">
      <vs-pagination
          :total="totalPages"
          v-model="page"
          @change="closeExpand"
          max="7"

      />
    </div>
  </div>
</template>

<script>
  import { formatRouteTenantPath, hasPermission } from '@/utils'
  import moduleCustomerGroup from '@/store/customerGroup/moduleCustomerGroup'
  import TableCategoryCustomers from './TableCategoryCustomers'

  export default {
    name: 'category',
    data() {
      return {
        page: 1,
        selected: [],
        itemsPerPage: 4,
        isMounted: false,
        confirmationPopup: false,
        chosenGroupToDelete: null,
        search: '',
        orderBy: {
          name: 'id',
          type: 'DESC'
        },
      }
    },
    watch: {
      'page'() {
        this.loadGroups();
      },
      'itemsPerPage'() {
        this.page = 1
        this.loadGroups();
      }
    },
    computed: {
      totalPages() {
        return this.$store.state.customerGroup && this.$store.state.customerGroup.groupsOfCustomer.total_pages
          ? this.$store.state.customerGroup.groupsOfCustomer.total_pages
          : 0;
      },
      currentPage() {
        if (this.isMounted) {
          return this.$refs.table.currentx;
        }

        return 0;
      },
      groupsOfCustomer() {
        return this.$store.state.customerGroup ? this.$store.state.customerGroup.groupsOfCustomer.items : [];
      },
      queriedItems() {
        return this.$store.state.customerGroup && this.$store.state.customerGroup.groupsOfCustomer.total_items
          ? this.$store.state.customerGroup.groupsOfCustomer.total_items
          : 0;
      }
    },
    methods: {
      async loadGroups() {
        if (!moduleCustomerGroup.isRegistered) {
          this.$store.registerModule('customerGroup', moduleCustomerGroup)
          moduleCustomerGroup.isRegistered = true
        }

        await this.$store.dispatch("customerGroup/fetchGroupsOfCustomerPaginated", {
          sortName: this.orderBy.name,
          page: this.page,
          itemsPerPage: this.itemsPerPage,
          type: this.orderBy.type,
          word: this.search
        });
      },
      addNewData() {
        this.$router.push(formatRouteTenantPath(`/crm/category/add`))
      },
      openConfirmationPopup(groupOfCustomerId) {
        this.chosenGroupToDelete = groupOfCustomerId
        this.confirmationPopup = true
      },
      deleteData() {
        this.closeExpand();
        this.$store.dispatch("customerGroup/deleteGroupOfCustomer", this.chosenGroupToDelete)
        .then(() => {
          this.chosenGroupToDelete = null
          this.confirmationPopup = false
          this.$vs.notify({
              title: "Sucesso",
              text: "Categoria deletada com sucesso",
              color: "success",
          });
          this.loadGroups();
        })
        .catch(err => { console.error(err) })
      },
      editData(groupOfCustomerId) {
        this.$router.push(formatRouteTenantPath(`/crm/category/edit/${groupOfCustomerId}`))
      },
      canSee(action) {
        return hasPermission(`category-${action}`)
      },
      searchFilter(searchQuery) {
        this.closeExpand();
        this.search = searchQuery;
        this.loadGroups();
      },
      sortFilter(sortName) {
        this.closeExpand();
        if (sortName !== null) {
          if (sortName !== this.orderBy.name) {
            this.orderBy.name = sortName;
            this.orderBy.type = 'ASC';
          } else if (this.orderBy.type !== "" && this.orderBy.type === "ASC") {
            this.orderBy.type = 'DESC';
          } else if (this.orderBy.name === sortName && this.orderBy.type === "DESC") {
            this.orderBy.name = 'name';
            this.orderBy.type = 'ASC';
          }
          this.loadGroups();
        }
      },
      closeExpand() {
        let $target = [];
        this.$refs.vsTrElement.forEach((element) => {
          if (element.expanded === true) {
            $target.push(element)
          }
        })
        $target.forEach((element) => {
          element.$el.click();
        })
      }
    },
    async mounted() {
      await this.loadGroups();
      this.isMounted = true;
    },
    components: {
      TableCategoryCustomers
    },
    beforeRouteLeave(to, from, next) {
      if (this.confirmationPopup) {
          this.confirmationPopup = false;
          setTimeout( ()=> {
          next();
          }, 2);
      }
      else {
          next();
      }
    },
  }
</script>

<style lang="scss">
  #category {
    .vs-con-table {
      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;


        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
